module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am199-154071d5e69e20700480ab5e4a8b435b.jpg";